import React from "react";
import {
  getBuyGetText,
  isBuyOrGet,
} from "../../../../../../../../../../../../types/product/ibrief-product/ibrief-product.functions";
import { ProductHistory } from "../../../../../../../../../../../../features/product-history/components/product-history.component";
import { BasicResourceType } from "../../../../../../../../../../../../types/resources/resources.enums";

import {
  ButtonsContainer,
  BuyGetLabel,
} from "./flyer-detail-page-form-position-position-products-table-extras.styles";
import { FlyerDetailPageFormPositionPositionProductsTableExtrasProps } from "./flyer-detail-page-form-position-position-products-table-extras.props";

export const ProductsTableExtras = (
  props: FlyerDetailPageFormPositionPositionProductsTableExtrasProps
) => {
  const showBuyGet = () => isBuyOrGet(props.product.buyGetStatus);

  const Container = showBuyGet() ? BuyGetLabel : ButtonsContainer;
  const buyGetText = showBuyGet() ? getBuyGetText(props.product.buyGetStatus) : null;

  return (
    <Container>
      {buyGetText}

      <ProductHistory
        buttonText=""
        resourceId={props.product.id}
        resourceType={BasicResourceType.FlyerPagePositionProduct}
        useIcon
      />
    </Container>
  );
};
